export default __webpack_public_path__ + "static/media/madison_ally.f929374f.svg";